import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ContributionRuleCalculation  {
    _originalTypeClassName = "zERP.BO.ContributionRuleCalculation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ContributionRuleCalculation.translate = translateService;
}
this.CalculationSalaryRules = [];
this.Id = null;
this.ForEmployee = false;
this.IsPercentage = false;
this.ParameterValue = null;
this.ValueCalculationType = null;
this.HasInsuredAmountLimits = false;
this.UpperMonthlyInsuredAmount = null;
this.LowerMonthlyInsuredAmount = null;
this.InsuredReductionToDailySalary = false;
this.HasContibutionLimits = false;
this.UpperMonthlyContributionAmount = null;
this.LowerMonthlyContributionAmount = null;
this.ContributionReductionToDailySalary = false;
this.CheckInsuranceDate = false;
this.InsuranceDateLimit = null;
this.CalculationBase = null;
this.Subsidise = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ForEmployee:any;
IsPercentage:any;
ParameterValue:any;
ValueCalculationType:any;
HasInsuredAmountLimits:any;
UpperMonthlyInsuredAmount:any;
LowerMonthlyInsuredAmount:any;
InsuredReductionToDailySalary:any;
HasContibutionLimits:any;
UpperMonthlyContributionAmount:any;
LowerMonthlyContributionAmount:any;
ContributionReductionToDailySalary:any;
CheckInsuranceDate:any;
InsuranceDateLimit:any;
CalculationBase:any;
Subsidise:any;
CalculatedExpression:any;
CalculationSalaryRules:any;
SubsidyRules:any;
Variable:any;
static setCalculatedExpression = ($this, value) => {
var oldValue = $this.CalculatedExpression;
$this.CalculatedExpression = value;
if (value != null) {
}
}
static setCalculationSalaryRules = ($this, items) => {
                if (items == null) items = [];
                if ($this.CalculationSalaryRules == null) $this.CalculationSalaryRules = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CalculationSalaryRules.length > 0) {
                    Domain.ContributionRuleCalculation.removeCalculationSalaryRules($this, $this.CalculationSalaryRules[0]);
                }

                Domain.ContributionRuleCalculation.addManyCalculationSalaryRules($this, copyItems);
            }
static addManyCalculationSalaryRules = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ContributionRuleCalculation.addCalculationSalaryRules($this, items[i]);
                }
            }
static addCalculationSalaryRules = ($this, item) => {
                if ($this.CalculationSalaryRules == null) $this.CalculationSalaryRules = [];
                if (item == null || $this.CalculationSalaryRules.indexOf(item) > -1) return;
                $this.CalculationSalaryRules.push(item);
}
static addRangeCalculationSalaryRules = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ContributionRuleCalculation.addCalculationSalaryRules($this, item));
            }
static removeCalculationSalaryRules = ($this, item) => {
                if ($this == null || $this.CalculationSalaryRules == null || $this.CalculationSalaryRules.indexOf(item) === -1) return;
                var _index = $this.CalculationSalaryRules.indexOf(item);
                $this.CalculationSalaryRules.splice(_index, 1);
}
static clearCalculationSalaryRules = ($this) => { $this.CalculationSalaryRules = null; }
static setSubsidyRules = ($this, value) => {
var oldValue = $this.SubsidyRules;
$this.SubsidyRules = value;
if (value != null) {
}
}
static setVariable = ($this, value) => {
var oldValue = $this.Variable;
$this.Variable = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}